// app/javascript/controllers/sortable_controller.js
import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
    static values = { url: String }

    connect() {
        console.log("Sortable verbunden mit:", this.element)
        this.sortable = Sortable.create(this.element, {
            onEnd: this.onEnd.bind(this)
        })
    }

    async onEnd() {
        const ids = this.sortable.toArray()

        // CSRF Token aus dem Meta-Tag holen (Wichtig für Rails!)
        const token = document.querySelector('meta[name="csrf-token"]').content

        const response = await fetch(this.urlValue, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": token,
                "Accept": "application/json"
            },
            body: JSON.stringify({ positions: ids })
        })

        if (response.ok) {
            console.log("Reihenfolge gespeichert")
        }
    }
}
